import apiClient from "../authentication/utils/core/axios";

/**
 * Search for stocks and Users
 */
export const searchGlobalAPI = async (query) => {
  const response = await apiClient.get(`/search-field/?query=${query}`);
  if (response.status !== 200) throw new Error('Failed to search');
  return response.data; // { users, stocks }
};
